import { render } from "./rub-bank.vue?vue&type=template&id=a00a891e"
import script from "./rub-bank.vue?vue&type=script&lang=js"
export * from "./rub-bank.vue?vue&type=script&lang=js"

import "./rub-bank.vue?vue&type=style&index=0&id=a00a891e&lang=scss"

import exportComponent from "/Users/a/Documents/work/new/prnew/lk-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__